import React from 'react';
import { ICollection, IContent } from 'types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

interface Props {
  collection: ICollection;
}

function BannerCollection({ collection }: Props) {
  return (
    <div>
      <Swiper
        loop
        spaceBetween={0}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        modules={[Autoplay]}
      >
        {collection.contents?.map((c) => {
          const { id, thumbnailUrl } = c as IContent;
          return (
            <SwiperSlide key={id}>
              <img src={thumbnailUrl} alt="" css={{ width: '100%' }} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default BannerCollection;
